import React from "react";
import Button from "shared/Button";
import styled from "styled-components";
import AboutUsInfo from "./components/AboutUsInfo";
import { SUPPORTINGCHARITYDATA } from "utilities/data";
import SupportCharityBG from "assets/images/jpgs/supportCharityBG.jpg";
import { Link } from "react-router-dom";

const Supporting = () => {
  return (
    <Wrapper>
      <div className="flex items-center gap-6 justify-between h-full max-md:flex-col px-16 max-[450px]:px-8 py-12">
        <div className="md:w-1/2">
          <AboutUsInfo
            body={SUPPORTINGCHARITYDATA.body}
            buttonText={SUPPORTINGCHARITYDATA.buttonText}
            buttonColor="#FFFFFF"
            pfont="text-[24px]"
          />
          <Link to="/about">
            <Button className="bg-[#FFFFFF]">LEARN MORE</Button>
          </Link>
        </div>
        <div className="flex flex-col md:w-1/2 pt-3">
          <div className="mb-4">
            <p className="font-bold text-[28px] leading-[33px]">
              Start supporting charity projects in 3 easy steps.
            </p>
          </div>
          <div className="flex items-stretch">
            <div className="mt-6 mr-6 flex flex-col justify-between items-baseline relative">
              <NumberDiv>01</NumberDiv>
              <NumberDiv>02</NumberDiv>
              <NumberDiv>03</NumberDiv>
              <div className="absolute top-0 left-5 z-1 h-full border-l-2 border-dashed border-[#F0CA18]"></div>
            </div>
            <div className="flex flex-col">
              <div className="py-6">
                <p className="font-medium leading-[28px] text-[18px]">
                  Choose how you want to give; donate cash, items or volunteer
                  your skills.
                </p>
              </div>
              <div className="py-6">
                <p className="font-medium leading-[28px] text-[18px]">
                  Search and choose specific categories of charity projects you
                  want to give to (e.g., education, health, displaced persons
                  etc.) and how often you want to give.
                </p>
              </div>
              <div className="py-6">
                <p className="font-medium leading-[28px] text-[18px]">
                  Give to the charity project and get reports on how your
                  donation has made an impact.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Supporting;

const Wrapper = styled.div`
  background-image: url(${SupportCharityBG}),
    linear-gradient(270deg, #011f5b 0%, #42528e 130.97%);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
`;
const NumberDiv = styled.div`
  background: linear-gradient(
    134.49deg,
    #f0ca18 10.28%,
    rgba(245, 114, 0, 0.9) 117.96%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 1rem;
  font-weight: 700;
  font-size: 12px;
  line-height: 21px;
  color: #000;
  z-index: 2;
`;
